var map = {
	"./alex": 351,
	"./alex.js": 351,
	"./class_cloud": 352,
	"./class_cloud.js": 352,
	"./config_app": 353,
	"./config_app.js": 353,
	"./curate_app": 354,
	"./curate_app.js": 354,
	"./english_duniya": 355,
	"./english_duniya.js": 355,
	"./learn_app": 356,
	"./learn_app.js": 356,
	"./quiz_egg": 357,
	"./quiz_egg.js": 357,
	"./shipmnt": 358,
	"./shipmnt.js": 358,
	"./tangible": 179,
	"./tangible.js": 179,
	"./tangibleProject": 359,
	"./tangibleProject.js": 359
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;


//////////////////
// WEBPACK FOOTER
// ./src/Projects ^\.\/.*$
// module id = 724
// module chunks = 0